/** Preserve the sender's clock while normalizing legacy 12-hour labels. */
export function formatChatTime(value: string): string {
  const match = value.trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (!match) return value;
  const hour = Number(match[1]);
  if (hour < 1 || hour > 12 || Number(match[2]) > 59) return value;
  return `${String(hour % 12 + (match[3].toUpperCase() === 'PM' ? 12 : 0)).padStart(2, '0')}:${match[2]}`;
}
